module.exports = __webpack_public_path__ + "img/21.9ad713da.jpg";